// packages/data/src/components/registry-provider/context.js
import { createContext } from "@wordpress/element";
import defaultRegistry from "../../default-registry";
var Context = createContext(defaultRegistry);
Context.displayName = "RegistryProviderContext";
var { Consumer, Provider } = Context;
var RegistryConsumer = Consumer;
var context_default = Provider;
export {
  Context,
  RegistryConsumer,
  context_default as default
};
//# sourceMappingURL=context.js.map
